import { Button } from '@components/ui/Button';
import { Information } from '@components/ui/Information';
import { EMAIL_ENVIRONMENT } from '@config/environment';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

const SUPPORT_EMAIL = EMAIL_ENVIRONMENT.SUPPORT_EMAIL;

const ReloadPageError = () => {
  return (
    <div className="flex h-screen items-center justify-center">
      <Information className="max-w-md gap-4">
        <ExclamationCircleIcon className="size-10 text-destructive" />
        <Information.Title>
          Hubo un error al cargar la página.
        </Information.Title>
        <Information.Description>
          Intente recargando la página. Si el error continúa, contáctese con{' '}
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="font-semibold text-foreground hover:underline"
          >
            {SUPPORT_EMAIL}
          </a>
          .
        </Information.Description>

        <Button
          variant="secondary"
          onClick={() => {
            window.location.reload();
          }}
        >
          Recargar página
        </Button>
      </Information>
    </div>
  );
};

export { ReloadPageError };
